import { render, staticRenderFns } from "./notasFichaCliente.vue?vue&type=template&id=6515a4b5"
import script from "./notasFichaCliente.vue?vue&type=script&lang=js"
export * from "./notasFichaCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports